import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicBombey from "../Components/ProjPicBombey";

const ProjectPageBombey = () => {
    return (
        <>
            <Navbar />
            <ProjPicBombey />
            <Footer />
        </>
    );
};

export default ProjectPageBombey;
